export default {
  "title": "FreeDive Ai",
  "heroHeadline": "每天训练，提升您的自由潜水技能！",
  "heroSubheadline": "专为自由潜水员、渔猎者和美人鱼打造的终极AI闭气训练应用。",
  "featuresHeader": "为什么选择 FreeDive Ai？",
  "featuresSubtitle": "下潜更深、闭气更久、保持安全所需的一切。",
  "feature1Title": "AI闭气训练",
  "feature1Desc": "AI根据您的个人最佳成绩生成定制的CO2和O2训练表，安全地延长您的闭气时间。",
  "feature2Title": "智能日志本",
  "feature2Desc": "记录您的自由潜水和渔猎活动。一站式追踪深度、时间、心率和血氧饱和度。",
  "feature3Title": "比赛与执照",
  "feature3Desc": "管理您的自由潜水执照，并随时获取全球比赛和活动的最新资讯。",
  "screenshotsTitle": "应用截图",
  "copyright": "© DomiLabs. All rights reserved."
};
